<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/corretor/vendas"
              >Vendas</router-link
            >
          </li>
          <li class="breadcrumb-item active">Detalhes da Venda</li>
        </ol>

        <!-- Dados usuário-->
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-info"></i>Dados do responsável financeiro</h2>
          </div>
          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label>Nome</label>
                <input
                  v-model="assinante.name"
                  class="form-control"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Sobrenome</label>
                <input
                  v-model="assinante.last_name"
                  class="form-control"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Telefone</label>
                <input
                  class="form-control"
                  v-mask="'(##) 9####-####'"
                  type="tel"
                  v-model="assinante.telefone"
                  @blur="
                    (e) => {
                      if (e.target.value.split(' ')[1]) {
                        assinante.phones.number = e.target.value
                          .split(' ')[1]
                          .replace('-', '');
                        assinante.phones.area_code = e.target.value
                          .split(' ')[0]
                          .replace(/[^0-9]/g, '');
                      }
                    }
                  "
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Cpf</label>
                <input
                  class="form-control"
                  type="tel"
                  v-mask="'###.###.###-##'"
                  v-model="assinante.cpf"
                  @blur="
                    (e) =>
                      (assinante.cpf = e.target.value.replace(/[^0-9]/g, ''))
                  "
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>E-mail</label>
                <input
                  v-model="assinante.email"
                  class="form-control"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Senha</label>
                <input
                  class="form-control"
                  type="password"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>CEP</label>
                <input
                  class="form-control"
                  v-model="assinante.zip_code"
                  type="tel"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Cidade</label>
                <input
                  class="form-control"
                  v-model="assinante.city"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-1">
              <div class="form-group">
                <label>Estado</label>
                <input
                  class="form-control"
                  v-model="assinante.state"
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Bairro</label>
                <input
                  class="form-control"
                  v-model="assinante.district"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Rua</label>
                <input
                  class="form-control"
                  v-model="assinante.street"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-1">
              <div class="form-group">
                <label>Número</label>
                <input
                  class="form-control"
                  type="number"
                  v-model="assinante.street_number"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label>Complemento</label>
                <input
                  class="form-control"
                  v-model="assinante.complement"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-users"></i>Participantes</h2>
          </div>

          <template v-for="(participante, index) in participantes">
            <div :key="index">
              <div class="row">
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Nome</label>
                    <input
                      v-model="participantes[index].name"
                      class="form-control"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Data de nascimento</label>
                    <input
                      class="form-control"
                      v-mask="'##/##/####'"
                      readonly
                      v-model="participantes[index].birth_date"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>RG</label>
                    <input
                      v-model="participantes[index].rg"
                      class="form-control"
                      type="tel"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Cpf</label>
                    <input
                      class="form-control"
                      type="tel"
                      v-mask="'###.###.###-##'"
                      v-model="participantes[index].cpf"
                      @blur="
                        (e) =>
                          (participantes[index].cpf = e.target.value.replace(
                            /[^0-9]/g,
                            ''
                          ))
                      "
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>CNS (Não obrigatório)</label>
                    <input
                      class="form-control"
                      readonly
                      v-model="participantes[index].cns"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <div class="form-group">
                    <label>E-mail</label>
                    <input
                      class="form-control"
                      type="email"
                      v-model="participantes[index].email"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Naturalidade</label>
                    <input
                      class="form-control"
                      v-model="participantes[index].naturalidade"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Planos</label>
                    <select 
                      id="plans" 
                      class="form-control"
                      v-model="participantes[index].plan_id"
                      readonly
                    >
                      <template v-for="plano in planos">
                        <option value="" selected disabled hidden v-bind:key="plano.plano.name">Escolha um plano</option>
                        <option disabled :key="plano.id" :id="plano.id" :value="`${plano.plano.id}`">
                          {{`${plano.plano.id} - ${plano.plano.name}`}}
                        </option>
                      </template>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Nome da mãe</label>
                    <input
                      class="form-control"
                      v-model="participantes[index].nome_mae"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Nome do pai</label>
                    <input
                      class="form-control"
                      v-model="participantes[index].nome_pai"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label>Parentesco</label>
                    <select
                      v-model="participantes[index].parentesco"
                      class="form-control"
                      readonly
                    >
                      <option disabled selected>Selecione o parentesco.</option>
                      <option disabled value="Nenhum, sou responsável financeiro">
                        Nenhum, sou responsável financeiro
                      </option>
                      <option disabled value="Conjuguê">Cônjugue</option>
                      <option
                        disabled
                        value="Convivente, sem eventual concorrência com o cônjuge, salvo por decisão judicial"
                      >
                        Convivente, sem eventual concorrência com o cônjuge,
                        salvo por decisão judicial
                      </option>
                      <option
                        value="Filhos solteiro, até 21 anos incompletos, ou até 24 anos incompletos, desde que cursando graduação em nível superior de ensino"
                      >
                      Filhos solteiro, até 21 anos incompletos, ou até 24 anos incompletos, desde que cursando graduação em nível superior de ensino
                      </option>
                      <option
                        value="Enteado, o menor sob a guarda por força de decisão judicial e o menor tutelado, que ficam equiparados aos filhos"
                      >
                        Enteado, o menor sob a guarda por força de decisão
                        judicial e o menor tutelado, que ficam equiparados aos
                        filhos
                      </option>
                      <option
                        value="Neto(a)/bisneto(a)"
                      >
                      Neto(a)/bisneto(a)
                      </option>
                      <option value="Irmão(ã)">
                        Irmão(ã)
                      </option>
                      <option value="Pais, avós e bisavós">
                        Pais, avós e bisavós
                      </option>
                      <option value="Tio(a)">
                        Tio(a)
                      </option>
                      <option value="Sogro(a)">
                        Sogro(a)
                      </option>
                      <option value="Genro/nora">
                        Genro/nora
                      </option>
                      <option value="Cunhado(a)">
                        Cunhado(a)
                      </option>
                      <option value="Padrasto/madrasta">
                        Padrasto/madrasta
                      </option>
                      <option value="Sobrinho(a)">
                        Sobrinho(a)
                      </option>
                      <!-- <option disabled value="Pais">Pais</option>
                      <option disabled value="Sogros">Sogros</option> -->
                    </select>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </template>

          
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-file"></i>Informações da Assinatura
            </h2>
          </div>
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label>Plano</label>
                <input 
                  v-model="assinante.subscription.plans_description"
                  readonly
                  type="text"
                  class="form-control"/>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Valor</label>
                <money 
                  v-model="assinante.subscription.custom_price"
                  readonly
                  v-bind="money" 
                  type="text"
                  class="form-control">
                </money>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Status</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="assinante.subscription.status"
                  readonly
                >
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label>Protocolo</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="assinante.subscription.protocolo"
                  readonly
                >
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>Data cobrança</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="assinante.subscription.created_at"
                  readonly
                >
              </div>
            </div>
          </div>
        </div>      
      </div>
    </div>
  </div>
</template>

<script>

import moment from "moment";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import { Money } from "v-money";

export default {
  components: {
    Money,
  },
  mixins: [funcoesGerais],
  data() {
    return {
      planos: [],
      assinante: {
        subscription:{
          plans_description: ""
        }
      },
      participantes: [],
      checkout: {
        cupom: null,
        billing_info: {
          credit_card: {
            holder_name: "",
            number: "",
            cvv: "",
            expiration_month: "",
            expiration_year: "",
          },
        },
      },
    };
  },
  mounted() {
    let self = this;
    self.isLoading = true;
    axios
      .get(`oportunidades_detalhes/${self.$route.params.id}`)
      .then((res) => res.data)
      .then((res) => {
        let assinante = {
          ...res.assinante,
          ...res.usuario,
          ...{ telefone: res.telefone.area_code + res.telefone.number },
          subscription: res.vendas[0],
        };
        let planoId = res.dependentes.map( dependente => dependente.plan_id);
        planoId.map( id => {
          axios
            .get(`detalhes/plano/${id}`)
            .then((res) => res.data)
            .then((res) => {
              self.planos.push(res);
            })
            .catch((err) => {
              self.isLoading = false;
              self.$swal.fire({
                position: "center",
                type: "error",
                title: "Erro",
                text: 'Erro ao buscar os planos',
                showConfirmButton: true,
              });
            });
        });
        self.assinante = assinante;
        self.assinante.subscription.created_at = self.padronizaDataCompleta(self.subtract_hours(res.vendas[0].created_at, 3));
        self.assinante.subscription.custom_price = res.vendas[0].custom_price/100;
        if (res.dependentes.length > 0) {
          self.participantes = res.dependentes;
        }
        for(let i=self.participantes.length; i<self.planos.length; i++){
          let particip = {
            plan_id: "",
            name: "",
            birth_date: "",
            cpf: "",
            rg: "",
            email: "",
            parentesco: "",
            nome_mae: "",
            nome_pai: "",
            carteirinha: "",
            naturalidade: "",
          }
          self.participantes[i] = particip
        }
        self.isLoading = false;
      })
      .catch((err) => {
        self.isLoading = false;
         self.$swal.fire({
            position: "center",
            type: "error",
            title: "Erro ao buscar oportunidade",
            text: err.response.data.message,
            showConfirmButton: true,
          });
      });
  },
  methods: {

    padronizaDataCompleta(data) {
      return data ? moment(String(data)).format("DD/MM/YYYY H:mm") : "";
    },

    subtract_hours(date, hours){
      let data = new Date(date)
      data.setHours(data.getHours() - hours);
      return data;      
    },
  },
};
</script>

<style scoped>
.input-horario {
  width: 50px;
  border: blue;
}

#map {
  width: 100%;
}

.btn-color {
  background-color: #af104c;
}

.badge-item {
  color: #af104c;
}
</style>